document.addEventListener('DOMContentLoaded', () => {
  const answers = document.querySelectorAll('.faq-accordion__answer');


  answers.forEach((answer) => {
    answer.style.overflow = 'hidden';
    answer.style.height = '0px';
  });

  document.querySelectorAll('.faq-accordion__question').forEach((question) => {
    question.addEventListener('click', () => {
      const item = question.closest('.faq-accordion__item');
      const answer = question.nextElementSibling;
      const isOpen = item.classList.contains('active');

      if (isOpen) {
        
        item.classList.remove('active');
        answer.style.height = '0px';
      } else {
        
        item.classList.add('active');
        answer.style.height = answer.scrollHeight + 'px';
      }
    });
  });
});